<div (click)="show($event)" style="display: flex;align-items: center;" class="pointer">
  <ion-label class="ion-text-right" style="width: 100%;min-width: 120px;">
    <h4>
      {{display}}
    </h4>
    <h4 *ngIf="!date" style="min-width: 120px;width: 100%;" [class.empty]="!date">
      {{placeholder}}
    </h4>
  </ion-label>
  <ion-icon slot="icon-only" color="tertiary" name="calendar"></ion-icon>
</div>
<ion-modal trigger="date">
  <ng-template>
    <ion-content force-overscroll="false">
      <ion-datetime
      size="cover"
      showDefaultButtons="true"
      [presentation]="presentation"
      cancelText="Annuler"
      doneText="Valider"
      [max]="max"
      [min]="min != null ? min: '2023-01-01'"
      [value]="date"
      (ionChange)="onChanged($event)"
    >
  </ion-datetime>
    </ion-content>
  </ng-template>
</ion-modal>